export default "__VITE_ASSET__BlbreTt7__";